const positive = (value)=>{
    if(value<=0 || isNaN(value)){
        return("Must be greater than zero")
    }
}
export default positive